export const Form = {
  baseStyle: {
    container: {
      position: 'relative',
      pb: 4,
      mb: 1,
    },
    helperText: { color: 'blueGray.400', fontSize: 'xs' },
    requiredIndicator: { color: 'product.text.state.error' },
  },
}
